
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.8 23.2c0-.7-.1-1.4-.4-1.6l-.2-.2c-1.7-2.8-5.3-5.3-7.6-7.6-.1-.2-.3-.3-.5-.3h-17c-.6-.1-.7 1.1-.7 1.5v34.3c0 .4.1 1.6.7 1.6h25c.6 0 .7-1.2.7-1.6V26.7c-.1-1.1.1-2.4 0-3.5zm-8-5.7c1 1.2 2.1 2.6 3.3 3.8h-3.3v-3.8zm6.6 30.3H20.8V16.6h15.7v5.8c-.1.8 0 1.8.5 2h7.4c-.1 1.4 0 2.8 0 4.1v19.3z"}}),_c('path',{attrs:{"d":"M32.8 9H14.7c-.6 0-.7 1.2-.7 1.6v35.7c0 1.9 1.4 1.9 1.4 0V12.2h17.4c1-.1 1-3.2 0-3.2z"}})])
          )
        }
      }
    